import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentPage: 1,
  itemsPerPage: 100,
  globalFilter: '',
};

const paginationSlice = createSlice({
  name: 'pagination',
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
      state.currentPage = 1;
    },
    setGlobalFilter: (state, action) => {
      state.globalFilter = action.payload;
    },
  },
});

export const { setCurrentPage, setItemsPerPage, setGlobalFilter } = paginationSlice.actions;
export default paginationSlice.reducer;
